import React, { useState } from 'react';
import PropTypes from 'prop-types';
import GenericSection from '../base_generic-section/component';
import { useEventListener } from '@utils/hooks';
import store from '@utils/store';

const DataTricsContainer = (props) => {
  const { hasContainer = true } = props;
  const [components, setComponents] = useState([]);
  const injectComponent = (event) => {
    const component = <GenericSection store={store} {...event?.detail}/>;
    setComponents([component]);
  };

  useEventListener('inject-datatrics', injectComponent);

  return (
    <div id="dt" className={`${hasContainer ? 'container' : ''} datatrics-container`}>{components}</div>
  );
};

DataTricsContainer.propTypes = {
  hasContainer: PropTypes.bool,
};

export default DataTricsContainer;
